import { useAssessmentTestInfo } from '@pages/discipline/assessments'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async () => {
  const { initAssessmentTest } = useAssessmentTestInfo()
  initAssessmentTest()
})
